import { css, jsx } from '@emotion/core';
import { Input } from 'antd';
import React, { useState } from 'react';
import { connect } from 'react-redux';

import Form from '@/src/shared/components/Form';
import { bp, colors } from '@/styles';

const styles = {
  inputContainer: css`
    width: 100%;
    margin: 1.6rem 0;
    @media ${bp.md} {
      max-width: 36.5rem;
    }
    .ant-input {
      border-width: 1px;
      border-style: solid;
      border-color: rgb(218, 217, 215);
    }
  `,
};

const TextInput = ({ form, info, register, step, currentInfo, key, onChange }) => {
  const [isPasswordValid, setPasswordValid] = useState(false);

  const handleConfirmBlur = e => {
    const {
      target: { value },
    } = e;
    setPasswordValid(isPasswordValid || !!value);
  };

  const validateFirstPassword = (rule, value, callback) => {
    if (value && value !== form.getFieldValue('Password')) {
      callback('Enter the same password.');
    } else {
      callback();
    }
  };

  const validateConfirmPassword = (rule, value, callback) => {
    if (value && isPasswordValid) {
      form.validateFields(['ConfirmPassword'], { force: true });
    }
    callback();
  };

  const passwordPattern = {
    pattern: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,25})'),
    message:
      'Passwords must be 8 – 25 characters long, containing at least 1 uppercase letter, 1 lowercase letter, and 1 number. In addition to alphabetic and numeric characters, symbolic characters and spaces are allowed.',
  };

  return (
    <>
      <div key={key} css={styles.inputContainer}>
        <Form.Item label="Password" hasFeedback>
          {form.getFieldDecorator('Password', {
            initialValue: register['Password'],
            rules: [
              {
                required: true,
                message: 'Enter password.',
              },
              {
                validator: validateConfirmPassword,
              },
              passwordPattern,
            ],
          })(
            <Input.Password
              visibilityToggle={false}
              onChange={e => {
                onChange('Password', e);
              }}
              size="large"
            />
          )}
        </Form.Item>
      </div>
      <div key={key} css={styles.inputContainer}>
        <Form.Item label="Confirm Password" hasFeedback>
          {form.getFieldDecorator('ConfirmPassword', {
            initialValue: register['ConfirmPassword'],
            rules: [
              {
                required: true,
                message: 'Please confirm your password.',
              },
              {
                validator: validateFirstPassword,
              },
              passwordPattern,
            ],
          })(
            <Input.Password
              visibilityToggle={false}
              onChange={e => {
                onChange('ConfirmPassword', e);
              }}
              size="large"
              onBlur={handleConfirmBlur}
            />
          )}
        </Form.Item>
      </div>
    </>
  );
};

const mapStateToProps = ({ register }) => {
  return {
    register,
  };
};

TextInput.defaultProps = {
  formOverrides: {},
  onChange: () => {},
};
export default connect(
  mapStateToProps,
  {}
)(TextInput);
